const GLYDER_LOGO_FILENAME = "Logo teal - white background.png";
const GLYDER_LOGO_PUBLIC_PATH = "/Logo%20teal%20-%20white%20background.png";
const GLYDER_NAV_LOGO_FILENAME = "glyder-nav-logo.png";
const GLYDER_NAV_LOGO_PUBLIC_PATH = "/glyder-nav-logo.png";
const GLYDER_LOGO_CACHE_BUST = "20260319";

const publicBase = process.env.PUBLIC_URL || "";

export const GLYDER_LOGO_FILE_PATH = `public/${GLYDER_LOGO_FILENAME}`;
export const GLYDER_LOGO_URL = `${publicBase}${GLYDER_LOGO_PUBLIC_PATH}?v=${GLYDER_LOGO_CACHE_BUST}`;
export const GLYDER_NAV_LOGO_FILE_PATH = `public/${GLYDER_NAV_LOGO_FILENAME}`;
export const GLYDER_NAV_LOGO_URL = `${publicBase}${GLYDER_NAV_LOGO_PUBLIC_PATH}?v=${GLYDER_LOGO_CACHE_BUST}`;

export default GLYDER_LOGO_URL;
